import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tx-dialog-prompt',
  templateUrl: './dialog-prompt.component.html',
  styleUrls: ['./dialog-prompt.component.scss'],
})
export class DialogPromptComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() confirmButtonText: string = '';
  @Input() rejectButtonText: string = '';
  @Input() showHeaderCloseButton: boolean = false;
  public returnValue: string = '';
  constructor(public activeModal: NgbActiveModal) {}
}

